import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import LayoutContainer from 'components/Common/LayoutContainer'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import LeLiveHeading from './LeLiveHeading'
import Image from 'components/Common/Image'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const SectionWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${rem(8)};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${rem(462)};
`

const BackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: ${rem(64)} ${rem(20)};
  display: flex;
  justify-content: center;

  ${mediaQueryUp.desktop} {
    justify-content: flex-start;
    padding: ${rem(64)} ${rem(60)};
  }
`

const Card = styled(Sheet)`
  position: relative;
  max-width: ${rem(331)};
  width: 100%;

  ${mediaQueryUp.desktop} {
    max-width: ${rem(430)};
  }
`

const InviteOnlyPill = styled.div`
  position: absolute;
  top: ${rem(-20)};
  left: 50%;
  transform: translateX(-50%);
  background-color: #b7410e;
  border: ${rem(1)} solid #f3f1ea;
  border-radius: ${rem(1000)};
  padding: ${rem(8)} ${rem(20)};
  white-space: nowrap;
`

function LeLiveVipLounge() {
  const intl = useIntl()
  const cathayPacificLogoAlt = intl.formatMessage({
    id: 'z77LrcNwEY2xfvnGoDsA',
    defaultMessage: 'Cathay Pacific',
    description: 'Alt text for the Cathay Pacific sponsor logo shown in the LE Live VIP lounge section',
  })

  return (
    <section id="vip-lounge">
      <LayoutContainer>
        <SectionWrapper>
          <BackgroundImage>
            <Image
              id="u5af98mj8eh65cfrxso"
              alt=""
              width={1440}
              height={560}
              dpr={1}
              enhancedFormats
              fit="center"
              objectFit="cover"
            />
          </BackgroundImage>

          <Content>
            <Card padding="24 16" desktopPadding={24} borderRadius="M" background="neutral-eight">
              <InviteOnlyPill>
                <BodyText variant="large" colour="neutral-eight" align="center">
                  {intl.formatMessage({
                    id: 'w1aUZopwB479Ic9y76GD',
                    defaultMessage: 'Invitation Only',
                    description: 'Badge label indicating invitation-only access restriction for VIP lounge section',
                  })}
                </BodyText>
              </InviteOnlyPill>

              <Group direction="vertical" gap={16} horizontalAlign="center">
                <Group direction="vertical" gap={0} horizontalAlign="center">
                  <LeLiveHeading variant="heading1alt" as="h2" align="center">
                    {intl.formatMessage({
                      id: 'Y8cuYaVPByYlnJzVzxtz',
                      defaultMessage: 'Société Lounge',
                      description: 'Main heading for the Société VIP lounge section on the LE Live event page',
                    })}
                  </LeLiveHeading>
                  <Group direction="horizontal" gap={16} verticalAlign="end">
                    <BodyText variant="small" colour="neutral-two" align="center">
                      {intl.formatMessage({
                        id: 'Uu1VRX7ljYyDRTcXczgG',
                        defaultMessage: 'Presented by',
                        description: 'Label text displayed before the Cathay Pacific sponsor logo in VIP lounge',
                      })}
                    </BodyText>
                    <Image
                      id="aq931u2xbi6gpmlfwu6"
                      alt={cathayPacificLogoAlt}
                      height={24}
                      dpr={2}
                      enhancedFormats={false}
                    />
                  </Group>
                </Group>

                <BodyText variant="large" colour="neutral-two" align="center">
                  {intl.formatMessage({
                    id: 'RDiE3-6WdqBT82tgzWA0',
                    defaultMessage: 'LuxPlus+, Société Gold and Platinum members and Cathay Diamond Members are invited to unwind in the exclusive Société VIP Lounge – a premium retreat featuring complimentary champagne and canapes.',
                    description: 'Description of VIP lounge eligibility and amenities',
                  })}
                </BodyText>
              </Group>
            </Card>
          </Content>
        </SectionWrapper>
      </LayoutContainer>
    </section>
  )
}

export default LeLiveVipLounge
